// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"beg_a bhc_tp","StrollerBoxWidget__imageCounselling":"beg_b bhc_ke"};